<template>
  <div class="modal-mask">
    <a-spin ref="spinRef" :spinning="spinning">
      <a-modal
        v-model="visible"
        title="单词详情"
        :destroy-on-close="true"
        :footer="null"
        :mask="false"
        :mask-closable="false"
        dialog-class="answer-modal"
        :get-container="() => $refs.spinRef.$el.querySelector('.ant-spin-container')"
        :after-close="afterClose"
        width="450px"
      >
        <div class="modal-content">
          <div class="answer-overall">
            <div :class="['answer-text', 'mb-15', evaluateTextColor]">{{ wordName }}</div>
            <div class="word-play">
              <div class="pronounce">
                {{ soundType }}
                <img src="@/assets/common/switch_blue.png" alt="" @click="changeSoundType" />
              </div>
              <div class="gap">/</div>
              <div class="phonetic">{{ soundMark }}</div>
              <div class="play" @click="playContent">
                <img v-if="isPlaying && playAudioType === 'content'" src="@/assets/common/black_pause.png" alt="" />
                <img v-else src="@/assets/common/black_play.png" alt="" />
              </div>
            </div>
            <div class="paraphrase">
              {{ wordDetail.paraphrase }}
            </div>
          </div>
          <div v-if="textEvaluate" class="answer-evaluate">
            <div v-if="textEvaluate.result.details" class="word-evaluate">
              <div class="word-evaluate-container">
                <template v-for="detail in textEvaluate.result.details">
                  <template v-for="(item, index) in detail.phone">
                    <PhoneProgress :key="index" :ratio="item.score" :content="item.char" />
                  </template>
                </template>
              </div>
            </div>
            <div
              :class="[
                'answer-score',
                textEvaluate.result.scoreRate >= 85
                  ? 'col-1DC060'
                  : textEvaluate.result.scoreRate >= 60
                    ? 'col-FFA516'
                    : 'col-FF3C30'
              ]"
            >
              <template v-if="$store.getters.isGradeSchool">
                <img :src="Grade2ImgSrc(Number(textEvaluate.result.overall))" alt="" class="score-img" />
              </template>
              <template v-else>
                <span class="score">
                  {{ Number(textEvaluate.result.overall).toFixed(2) }}
                </span>
              </template>
            </div>
          </div>
          <div class="word-audio">
            <div class="word-audio-item" @click="playContent">
              <img v-if="isPlaying && playAudioType === 'content'" src="@/assets/common/black_pause.png" alt="" />
              <img v-else src="@/assets/common/black_play.png" alt="" />
              <div>播放音频</div>
            </div>
            <div class="word-audio-item record" @click="egStartRecord">
              <template v-if="egRecordState">
                <img src="@/assets/common/record.gif" alt="" />
                <div>点击结束录音</div>
              </template>
              <template v-else>
                <img src="@/assets/common/record.png" alt="" />
                <div>点击录音</div>
              </template>
            </div>
            <div class="word-audio-item" @click="playRecord">
              <img v-if="isPlaying && playAudioType === 'record'" src="@/assets/common/record_play_black.gif" alt="" />
              <img
                v-else
                :src="
                  recordUrl
                    ? require('@/assets/common/record_play_black.png')
                    : require('@/assets/common/listen_record.png')
                "
                alt=""
              />
              <div>回听录音</div>
            </div>
          </div>
          <audio ref="myAudio" @play="onplay" @pause="onpause" />
        </div>
      </a-modal>

      <Sidebar v-if="visible" class="wait-answer" direction="right" @isFold="isFold">
        <template v-slot:content>
          <WaitingList
            v-show="rightFold"
            ref="waitingListRef"
            :answer-data="answerData"
            :answer-state="answerState"
            :is-team-answering="isTeamAnswering"
            :play-type="playType"
            :student-list="studentList"
            :team-answer-start-btn-disabled="!isFinishEvaluating"
            can-team-change-student
            @checkAnswer="checkAnswerDetail"
            @playTypeChange="changePlayType"
            @startRespond="egStartRecord"
            @teamAnswerEnd="endTeamAnswer"
            @teamAnswerStart="startTeamAnswer"
          />
        </template>
      </Sidebar>
    </a-spin>
  </div>
</template>

<script>
import PhoneProgress from '@/components/answer/PhoneProgress'
import { selectByWordName, studentListByClazzId } from '@/api/common'
import { Grade2ImgSrc, setDefaultStudent } from '@/utils'
import AudioData from '@/utils/audioData'
import WaitingList from '@/components/common/WaitingList.vue'
import { sendMessage } from '@/utils/dtq'
import { readLocalFile, readLocalFileBuffer } from '@/utils/electronUtils'
import { getFileExtension } from '@/utils/fileUtils'
export default {
  name: 'WordModal',
  components: { WaitingList, PhoneProgress },
  data() {
    return {
      visible: true,
      spinning: false,
      isPlaying: false, // 播放状态
      egRecordState: false, // 录音状态
      textEvaluate: null,
      recordUrl: '', // 录音音频
      contentUrl: '', // 单词音频
      playAudioType: 'content', // 播放音频类型 content单词音频 record录音
      wordName: '',
      wordDetail: {},
      soundMark: '',
      soundType: '美音',
      rightFold: true,
      answerData: {},
      answerState: '',
      isTeamAnswering: false,
      studentList: [],
      playType: 'SINGLE', // 作答模式 TEAM集体作答 SINGLE单人作答 ALL全班作答
      deviceRespondence: false,
      answerDeviceData: {
        buffer: null, // 录音数据
        fileExtension: '' // 文件后缀
      },
      audioData: null,
      engineEvaluateTimeOut: null,
      allowMicrophone: true, // 是否允许使用麦克风
      engineEvaluate: null,
      onClose: null
    }
  },
  computed: {
    evaluateTextColor() {
      if (!this.textEvaluate) return ''
      return this.textEvaluate.result.scoreRate >= 85
        ? 'col-1DC060'
        : this.textEvaluate.result.scoreRate >= 60
          ? 'col-FFA516'
          : 'col-FF3C30'
    },
    // 班级信息
    classData() {
      return this.$store.getters.classData || {}
    },
    // 当前作答人
    activeStudent() {
      return this.$store.getters.activeAnswer
    },
    isFinishEvaluating() {
      const num =
        this.studentList.filter(el => el.answerState === 'recording' || el.answerState === 'evaluating').length || 0
      return num <= 0
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.$bus.$emit('wordModalVisible', val)
      },
      immediate: true
    },
    textEvaluate(val) {
      if (!val) {
        this.recordUrl = ''
        return
      }
      this.recordUrl = val.audioUrl
    },
    activeStudent(val) {
      sendMessage({ fun: 'dtq_tag_set', uID: 0, msg: '' })
      sendMessage({ fun: 'dtq_echo_set', uID: 0, msg: '' })
      if (!val) return
      if (this.answerData[val.id]) {
        this.textEvaluate = this.answerData[val.id]
        return
      }
      this.textEvaluate = null
      // 绑定了设备，并且是单人作答，激活学生时才会下发作答指令
      if (val.isBindAnswerDevice && this.playType === 'SINGLE') {
        this.egStartRecord()
      }
    }
  },
  mounted() {
    this.init()
    // 答题器事件总线
    this.$bus.$on('dtqMessage', this.handleDTQMessage)
  },
  beforeDestroy() {
    console.log(321321)
    this.$bus.$off('dtqMessage', this.handleDTQMessage)
  },
  methods: {
    Grade2ImgSrc,
    init() {
      this.spinning = true
      this.audioData = new AudioData()
      studentListByClazzId({ clazzId: this.classData.id }).then(res => {
        const { state, data } = res
        if (state !== 11) return
        this.studentList = setDefaultStudent(data || [])
      })
      this.common.checkAllowMicrophone().then(allowMicrophone => {
        this.allowMicrophone = allowMicrophone
        if (!allowMicrophone) {
          this.$message.error('当前设备无法录音')
        }
        this.initializeEngineEvaluate()
      })
    },
    initWord() {
      // if (!this.wordName) return
      selectByWordName({ wordName: this.wordName })
        .then(res => {
          if (res.state !== 11) return
          const data = res.data
          if (!data) {
            this.$message.error('该单词暂无详情')
            return
          }
          this.wordDetail = data
          this.soundMark = data.usaSoundMark
          this.contentUrl = data.usaPronunciation
          this.isPlaying = false
        })
        .finally(() => {
          this.spinning = false
        })
    },
    // 初始化评测引擎
    initializeEngineEvaluate() {
      this.spinning = true
      this.initializeEngineEvaluateTimeOut()
      this.engineEvaluate = this.common.engineEvaluates(
        this.allowMicrophone,
        this.$store.getters.evaluateUserId,
        this.engineCallback,
        this.concatBuffer
      )
    },
    // 初始化评测引擎超时处理  超时时间为10.5秒
    initializeEngineEvaluateTimeOut() {
      this.engineEvaluateTimeOut = setTimeout(() => {
        if (this.spinning) {
          this.spinning = false
          this.$error({
            title: '连接超时，请检查网络',
            centered: true,
            onOk: () => {}
          })
        }
      }, 10500)
    },
    // 评测引擎回调
    engineCallback(err) {
      const self = this
      if (!err.state) {
        clearTimeout(self.engineEvaluateTimeOut)
        self.$error({
          content: err.note,
          okText: '取消',
          centered: true,
          onOk() {
            if (!err.micInit) {
              self.visible = false
            } else {
              self.spinning = false
            }
          }
        })
      } else if (err.state === 1) {
        self.spinning = false
        clearTimeout(self.engineEvaluateTimeOut)
      } else if (err.state === 2) {
        this.spinning = false
        clearTimeout(this.engineEvaluateTimeOut)
        this.initWord()
      } else if (err.state === 3) {
        self.egRecordState = false
        self.$confirm({
          content: err.note,
          okText: '重新录音评测',
          cancelText: '退出做题',
          centered: true,
          onOk() {
            self.egStartRecord()
          },
          onCancel() {
            self.visible = false
          }
        })
      }
    },
    // 合并缓冲
    concatBuffer(data, isLast) {
      if (data.length) {
        this.audioData.input(data)
        if (isLast) {
          this.isLast = true
        }
      }
    },
    async handleDTQMessage(data) {
      const self = this
      const uID = self.activeStudent?.answerDeviceId
      const answerStudent = this.studentList.find(el => el.answerDeviceId === data.uID)
      if (data.fun === 'voice_stream') {
        if (this.playType === 'TEAM') {
          if (answerStudent?.answerState === 'recording') return
          this.updateStudentState('recording', answerStudent.id)
          if (['98', 98, '4', 4].includes(answerStudent?.answerDeviceInfo?.answerDeviceType)) {
            sendMessage({ fun: 'dtq_tag_set', uID: data.uID, msg: '点击结束录音' })
            sendMessage({ fun: 'dtq_echo_set', uID: data.uID, msg: '录音中...' })
          } else {
            sendMessage({ fun: 'dtq_echo_set', uID: data.uID, msg: '松开结束录音    录音中...' })
          }
          return
        }
        if (self.deviceRespondence) return
        if (data.uID === uID) {
          if (['98', 98, '4', 4].includes(self.activeStudent?.answerDeviceInfo?.answerDeviceType)) {
            sendMessage({ fun: 'dtq_tag_set', uID, msg: '点击结束录音' })
            sendMessage({ fun: 'dtq_echo_set', uID, msg: '录音中...' })
          } else {
            sendMessage({ fun: 'dtq_echo_set', uID, msg: '松开结束录音    录音中...' })
          }
          self.deviceRespondence = true
          self.answerState = 'respond'
          self.egRecordState = true
          self.waitFunction()
          self.countDown(5, this.singleEndTeamAnswer)
        }
      }
      if (data.fun === 'voice_update') {
        sendMessage({ fun: 'dtq_tag_set', uID: data.uID, msg: '' })
        if (this.playType === 'TEAM') {
          sendMessage({ fun: 'dtq_echo_set', uID: data.uID, msg: '录音结束' })
          const temp = await readLocalFile(data.vo_path)
          const audioFile = await this.common.urlToFile(temp)
          sendMessage({ fun: 'dtq_echo_set', uID: data.uID, msg: '评测中' })
          this.updateStudentState('evaluating', answerStudent.id)
          this.fileParams.data.set('audio', audioFile)
          this.common
            .fetchFileEvaluate(this.fileParams)
            .then(res => {
              sendMessage({ fun: 'dtq_echo_set', uID: data.uID, msg: '评测完成' })
              this.updateStudentState('success', answerStudent.id)
              readLocalFileBuffer(data.vo_path).then(buffer => {
                answerStudent.answerDeviceData = {
                  buffer,
                  fileExtension: getFileExtension(data.vo_path, false)
                }
                this.egResultDone(res, true, answerStudent)
              })
            })
            .catch(err => {
              console.log('TEAM评测失败', err)
              this.updateStudentState('fail', answerStudent.id)
            })
          return
        }
        if (data.uID === uID) {
          self.evalTime = 0
          sendMessage({ fun: 'dtq_echo_set', uID, msg: '录音结束' })
          const tempUrl = await readLocalFile(data.vo_path)
          const audioFile = await this.common.urlToFile(tempUrl)
          sendMessage({ fun: 'dtq_echo_set', uID, msg: '评测中' })
          self.egStartRecord()
          this.fileParams.data.append('audio', audioFile)
          this.common
            .fetchFileEvaluate(this.fileParams)
            .then(res => {
              sendMessage({ fun: 'dtq_echo_set', uID, msg: '评测完成' })
              self.deviceRespondence = false
              readLocalFileBuffer(data.vo_path).then(buffer => {
                this.answerDeviceData.buffer = buffer
                this.answerDeviceData.fileExtension = getFileExtension(data.vo_path, false)
                self.egResultDone(res, true)
              })
            })
            .catch(err => {
              console.log(1434, '评测失败', err)
            })
        }
      }
    },
    isFold(val) {
      this.rightFold = val
    },
    checkAnswerDetail(data, userRealName) {
      this.textEvaluate = data
    },
    changePlayType(val) {
      this.answerData = {}
      this.textEvaluate = null
      this.studentList.forEach(item => {
        item.answerState = ''
      })
      this.playType = val
    },
    // 播放音频
    audioPlay(text) {
      if (this.isPlaying) {
        this.$refs.myAudio.pause()
      } else {
        this.$refs.myAudio.src = text
        this.$refs.myAudio.addEventListener('play', () => {
          this.isPlaying = true
        })
        this.$refs.myAudio.addEventListener('ended', () => {
          this.isPlaying = false
        })
        this.$refs.myAudio.addEventListener('pause', () => {
          this.isPlaying = false
        })
        this.$refs.myAudio.play()
      }
    },
    // 音频播放事件
    onplay() {
      this.isPlaying = true
    },
    // 音频暂停事件
    onpause() {
      this.isPlaying = false
    },
    // 集体作答下发作答指令
    startTeamAnswer() {
      this.isTeamAnswering = true
      this.teamAnswerList = []
      this.averageScore = 0
      this.updateStudentState('wait')
      sendMessage({ fun: 'dtq_ctl', uID: 0, led_cn: 3, led_c: 1 })
      if (['98', 98, '4', 4].includes(this.$store.getters.classDeviceType)) {
        sendMessage({ fun: 'answer_start', uID: 0, type: 16 })
        sendMessage({ fun: 'dtq_tag_set', uID: 0, msg: `请朗读单词` })
        sendMessage({ fun: 'dtq_echo_set', uID: 0, msg: this.wordName })
      } else {
        sendMessage({ fun: 'dtq_echo_set', uID: 0, msg: `请朗读单词      ${this.wordName}` })
        sendMessage({ fun: 'answer_start', uID: 0, type: 8 })
      }
      const params = {}
      params.coreType = 'en.word.score'
      params.saveAudio = 1
      params.compress = 'raw'
      params.refText = this.wordName
      params.attachAudioUrl = 1
      params.audioUrlScheme = 'https'
      params.evalTime = 5 * 1000
      this.fileParams = this.common.fileEngineParams(params, this.$store.getters.evaluateUserId)
      this.countDown(15, this.endTeamAnswer)
    },
    // 结束做答
    async endTeamAnswer() {
      this.isTeamAnswering = false
      this.studentList.forEach(el => {
        if (el.answerState === 'wait') {
          this.updateStudentState('', el.id)
          sendMessage({ fun: 'dtq_tag_set', uID: el.answerDeviceId, msg: '' })
          sendMessage({ fun: 'dtq_echo_set', uID: el.answerDeviceId, msg: '' })
        }
        if (el.answerState !== 'success' && el.answerDeviceId) {
          sendMessage({ fun: 'dtq_echo_set', uID: el.answerDeviceId, msg: '' })
          sendMessage({ fun: 'dtq_tag_set', uID: el.answerDeviceId, msg: '' })
        }
      })
      sendMessage({ fun: 'answer_start', uID: 0, type: 128 })
      // 当录音时间太短时，会丢失数据，所以延迟再结束作答一次
      setTimeout(() => {
        sendMessage({ fun: 'answer_start', uID: 0, type: 128 })
        this.studentList.forEach(el => {
          if (el.answerState === 'recording') {
            this.updateStudentState('', el.id)
            sendMessage({ fun: 'dtq_echo_set', uID: el.answerDeviceId, msg: '录音时间太短' })
          }
        })
      }, 1000)
      await this.isAllFinishedEvaluate()
      if (this.countDownPause) clearTimeout(this.countDownPause)
      this.duration = 0
    },
    updateStudentState(state, id) {
      this.studentList = this.studentList.map(el => {
        // 等待录音 wait 录音中 recording 评测中 evaluating 评测成功 success 评测失败 fail
        if (id) {
          if (id === el.id) {
            el.answerState = state
          }
        } else {
          el.answerState = state
        }
        return el
      })
      // this.studentList = JSON.parse(JSON.stringify(this.studentList)) // 保证子组件能刷新获取到最新的状态
    },
    // 轮询获取是否全部学生已完成评测-有学生答题状态(answerState)为录音中(recording)、评测中(evaluating)则存在未完成学生
    isAllFinishedEvaluate() {
      return new Promise(resolve => {
        const interval = setInterval(() => {
          if (this.isFinishEvaluating) {
            resolve()
            clearInterval(interval)
          }
        }, 500)
      })
    },
    egStartRecord() {
      if (this.isPlaying || this.isTeamAnswering) return
      if (!this.egRecordState) {
        const params = {}
        params.coreType = 'en.word.score'
        params.saveAudio = 1
        params.compress = 'raw'
        params.refText = this.wordName
        params.attachAudioUrl = 1
        params.audioUrlScheme = 'https'
        params.evalTime = 5 * 1000
        if (this.activeStudent?.isBindAnswerDevice) {
          this.fileParams = this.common.fileEngineParams(params, this.$store.getters.evaluateUserId)
          const uID = this.activeStudent?.answerDeviceId
          sendMessage({ fun: 'dtq_ctl', uID, led_cn: 3, led_c: 1 })
          if (['98', 98, '4', 4].includes(this.activeStudent.answerDeviceInfo?.answerDeviceType)) {
            sendMessage({ fun: 'answer_start', uID, type: 16, q_tim: 5 })
            sendMessage({ fun: 'dtq_tag_set', uID: uID, msg: `请朗读单词` })
            sendMessage({ fun: 'dtq_echo_set', uID: uID, msg: this.wordName })
          } else {
            sendMessage({ fun: 'answer_start', uID, type: 8, q_tim: 5 })
            sendMessage({ fun: 'dtq_echo_set', uID, msg: `请朗读单词      ${this.wordName}` })
          }
          // sendMessage({ fun: 'dtq_echo_set', uID, msg: '请开始录音' })
        } else if (this.playType === 'TEAM') {
          this.startTeamAnswer()
        } else {
          this.engineEvaluate?.startRecord(params, msg => {
            this.egResultDone(msg)
          })
          this.answerState = 'respond'
          this.egRecordState = true
          this.waitFunction()
          this.countDown(5)
        }
      } else {
        this.engineEvaluate?.stopRecord()
      }
    },
    // 等待函数
    waitFunction() {
      this.waitEvent = true
      setTimeout(() => {
        this.waitEvent = false
      }, 1500)
    },
    // 倒计时
    countDown(time, countDownEndCB) {
      if (time) {
        this.duration = time
      }
      let { duration } = this
      if (duration !== 0) {
        this.countDownPause = setTimeout(() => {
          duration -= 1
          this.duration = duration
          this.countDown(undefined, countDownEndCB)
        }, 1000)
      } else {
        countDownEndCB && countDownEndCB()
      }
    },
    egResultDone(msg, isAnswerDevice = false, answerStudent) {
      this.isUseAnswerDevice = isAnswerDevice
      this.answerState = 'success'
      this.egRecordState = false
      // 注意，注意，注意
      // 若允许使用麦克风，或来自于答题器的回调，则继续往下执行，否则直接跳出。
      // 不允许使用麦克风时，使用的是虚拟评测引擎，结果回调是没数据的，不需要处理
      if (!(this.allowMicrophone || isAnswerDevice)) {
        return
      }

      if (typeof msg === 'string') {
        msg = JSON.parse(msg)
      }

      const textEvaluate = JSON.parse(JSON.stringify(msg))
      textEvaluate.result = { ...textEvaluate.result, scoreRate: textEvaluate.result.overall }

      if (this.playType === 'TEAM') {
        // 集体作答不展示评测结果，可通过点击学生查看
        answerStudent.textEvaluate = textEvaluate
        sendMessage({ fun: 'dtq_tag_set', uID: answerStudent.answerDeviceId, msg: '' })
        sendMessage({
          fun: 'dtq_echo_set',
          uID: answerStudent.answerDeviceId,
          msg: String(textEvaluate.result.overall) + '分'
        })
        this.$set(this.answerData, answerStudent.id, textEvaluate)
      } else {
        this.textEvaluate = textEvaluate
        if (this.activeStudent && this.activeStudent.id && this.activeStudent.isBindAnswerDevice) {
          sendMessage({ fun: 'dtq_tag_set', uID: this.activeStudent.answerDeviceId, msg: '' })
          sendMessage({
            fun: 'dtq_echo_set',
            uID: this.activeStudent.answerDeviceId,
            msg: String(this.textEvaluate.result.overall) + '分'
          })
        }
        this.$set(this.answerData, this.activeStudent.id, this.textEvaluate)
      }
    },
    playRecord() {
      if (!this.recordUrl || this.egRecordState) return
      if (this.isPlaying) {
        if (this.playAudioType !== 'content') {
          this.$refs.myAudio.pause()
        }
      } else {
        this.playAudioType = 'record'
        this.$refs.myAudio.src = this.recordUrl
        this.$refs.myAudio.play()
      }
    },
    playContent() {
      if (this.egRecordState) return
      if (this.isPlaying) {
        if (this.playAudioType !== 'record') {
          this.$refs.myAudio.pause()
        }
      } else {
        this.playAudioType = 'content'
        this.$refs.myAudio.src = this.contentUrl
        this.$refs.myAudio.play()
      }
    },
    changeSoundType() {
      if (this.soundType === '美音') {
        this.soundType = '英音'
        this.contentUrl = this.wordDetail.enPronunciation
        this.soundMark = this.wordDetail.enSoundMark
      } else {
        this.soundType = '美音'
        this.contentUrl = this.wordDetail.usaPronunciation
        this.soundMark = this.wordDetail.usaSoundMark
      }
    },
    afterClose() {
      if (this.isPlaying) {
        this.$refs.myAudio.pause()
      }
      if (this.egRecordState) {
        this.engineEvaluate?.stopRecord()
      }
      // 清空选中的学生
      this.$store.dispatch('user/setActiveAnswer', null)
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

::v-deep .ant-spin-nested-loading,
::v-deep .ant-spin-container {
  width: 100%;
  height: 100%;
}

::v-deep .ant-spin-container {
  display: flex;
  justify-content: flex-end;
}

::v-deep .ant-modal {
  &.answer-modal {
    .ant-modal-content {
      border-radius: 24px;
      .ant-modal-header {
        height: 72px;
        background: url('@/assets/common/model_title.png');
        background-size: 100% 72px;
        border-radius: 24px 24px 0 0;
        padding: 22px 40px;
        .ant-modal-title {
          color: #333333;
          font-size: 20px;
          line-height: 28px;
          font-weight: bold;
        }
      }
      .ant-modal-close {
        top: 14px;
        right: 14px;
        .ant-modal-close-x {
          width: 44px;
          height: 44px;
          line-height: 44px;
        }
      }
      .ant-modal-body {
        border-radius: 0 0 24px 24px;
        padding: 0;
        .modal-content {
          padding-bottom: 28px;
          padding-top: 10px;
          .answer-overall {
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            .answer-score {
              display: flex;
              align-items: center;
              .score {
                font-size: 34px;
              }
              .text {
                margin-left: 4px;
                font-size: 18px;
              }
            }
            .answer-star {
              .answer-star-img {
                width: 16px;
                height: 16px;
                & + .answer-star-img {
                  margin-left: 4px;
                }
              }
            }
            .word-play {
              padding: 0 14px 0 6px;
              margin-bottom: 14px;
              display: flex;
              align-items: center;
              height: 40px;
              background: #f6f6f6;
              border-radius: 20px;

              .pronounce {
                width: 64px;
                height: 28px;
                background: #ffffff;
                border-radius: 14px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                  margin-left: 4px;
                  width: 12px;
                  height: 12px;
                  cursor: pointer;
                }
              }

              .gap {
                margin: 0 10px;
              }

              .play {
                img {
                  width: 22px;
                  height: 22px;
                  cursor: pointer;
                }
              }

              .phonetic {
                font-weight: 600;
                color: #333333;
                margin-right: 10px;
              }
            }
            .paraphrase {
              font-size: 17px;
              font-weight: 400;
              color: #333333;
              padding: 0 28px;
            }
            .answer-text {
              font-size: 44px;
              font-weight: 600;
              color: #333333;
              height: 62px;
              line-height: 62px;
            }
          }
          .answer-evaluate {
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            margin-top: 30px;
            .answer-score {
              font-size: 34px;
              font-weight: 500;
            }
            .word-evaluate {
              width: calc(100% - 80px);
              display: flex;
              justify-content: center;
              .word-evaluate-container {
                justify-content: center;
                width: 100%;
                overflow-x: auto;
                display: flex;
                &::-webkit-scrollbar {
                  height: 8px !important;
                }
                // 滚动条里面滑块
                &::-webkit-scrollbar-thumb {
                  border-radius: 8px !important;
                  border: 0;
                  /* 颜色 */
                  background: rgba(0, 0, 0, 0.1) !important;
                }
              }
            }
          }
          .word-audio {
            display: flex;
            justify-content: center;
            align-items: flex-end;
            margin-top: 48px;
            .word-audio-item {
              cursor: pointer;
              text-align: center;
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              img {
                width: 40px;
                height: 40px;
                margin-bottom: 10px;
              }
              &.record {
                margin: 0 60px;
                img {
                  width: 60px;
                  height: 60px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.score-img {
  width: 48px;
  height: 48px;
}

.wait-answer {
  width: 200px;
  z-index: 10000;
}
</style>
